import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import AgentBottomNav from "../../components/AgentBottomNav";
import PageContainer from "../../components/PageContainer";
import PageHeader from "../../components/PageHeader";
import AgentNavbar from "../../components/AgentNavbar";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
const Profile = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const isAgent = user?.role === "delivery-boy" || user?.role === "coAdmin";
  const [sidebarOpen, setSidebarOpen] = useState(false);
 const navigate = useNavigate();
  return (
    <div className="w-full min-h-screen overflow-x-hidden">
      {!isAgent && (
        <div className="flex">
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          <div className="flex-1 min-w-0">
            <Header
              onMenuClick={() => setSidebarOpen((s) => !s)}
              sidebarOpen={sidebarOpen}
            />
            <PageContainer>
              <Outlet />
            </PageContainer>
          </div>
        </div>
      )}

      {isAgent && (
        <div className="md:hidden">
          <AgentNavbar />
          <PageHeader
            title="My Deliveries"
            role="agent"
            variant="orange"
            leftContent={
              <button onClick={() => navigate(-1)}>
                <ArrowLeft size={22} />
              </button>
            }
            className="py-0"
          />
          <main>
            <Outlet />
          </main>
          <AgentBottomNav />
        </div>
      )}
    </div>
  );
};


export default Profile;
